import { render, staticRenderFns } from "./ServerLogsTable.vue?vue&type=template&id=3bd4c778&"
import script from "./ServerLogsTable.vue?vue&type=script&lang=js&"
export * from "./ServerLogsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports